import * as React from "react"
import { cn } from "@/lib/utils"

interface VentureCardProps extends React.HTMLAttributes<HTMLDivElement> {
  hover?: boolean
  glow?: boolean
}

const VentureCard = React.forwardRef<HTMLDivElement, VentureCardProps>(
  ({ className, hover = true, glow = false, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "rounded-lg border border-border bg-card p-4 md:p-6 transition-all duration-200",
        hover && "card-hover",
        glow && "glow-secondary",
        className
      )}
      {...props}
    />
  )
)
VentureCard.displayName = "VentureCard"

const VentureCardHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex flex-col space-y-1.5 pb-4", className)}
    {...props}
  />
))
VentureCardHeader.displayName = "VentureCardHeader"

const VentureCardTitle = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn("text-lg font-semibold leading-none tracking-tight", className)}
    {...props}
  />
))
VentureCardTitle.displayName = "VentureCardTitle"

const VentureCardDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn("text-sm text-muted-foreground", className)}
    {...props}
  />
))
VentureCardDescription.displayName = "VentureCardDescription"

const VentureCardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("", className)} {...props} />
))
VentureCardContent.displayName = "VentureCardContent"

export {
  VentureCard,
  VentureCardHeader,
  VentureCardTitle,
  VentureCardDescription,
  VentureCardContent,
}
